/** 지금 눌려 있는 포인터들. 창 캡처 단계에서 세어 React 처리기보다 먼저 안다. */
const pressedPointers = new Set<number>();
if (typeof window !== 'undefined') {
  window.addEventListener('pointerdown', (event) => pressedPointers.add(event.pointerId), true);
  const release = (event: PointerEvent): void => {
    pressedPointers.delete(event.pointerId);
  };
  window.addEventListener('pointerup', release, true);
  window.addEventListener('pointercancel', release, true);
}

const NO_CLEANUP = (): void => undefined;

/**
 * 요소가 보이도록 스크롤한다(가장 가까운 쪽). 포인터가 눌려 있으면(사진 위에서 영역을 누르고 끄는 중) 놓을 때까지 미룬다 —
 * 끄는 동안 화면이 스크롤되면 사진이 포인터 밑에서 움직여 끈 거리가 엉뚱해진다. 돌려준 함수는 미룬 스크롤을 거둔다.
 */
export const scrollIntoViewAfterRelease = (element: Element): (() => void) => {
  // jsdom 에는 scrollIntoView 가 없다.
  if (typeof element.scrollIntoView !== 'function') return NO_CLEANUP;
  if (pressedPointers.size === 0) {
    element.scrollIntoView({ block: 'nearest' });
    return NO_CLEANUP;
  }
  const cleanup = (): void => {
    window.removeEventListener('pointerup', onRelease);
    window.removeEventListener('pointercancel', onRelease);
  };
  function onRelease(): void {
    if (pressedPointers.size > 0) return;
    cleanup();
    if (element.isConnected) element.scrollIntoView({ block: 'nearest' });
  }
  window.addEventListener('pointerup', onRelease);
  window.addEventListener('pointercancel', onRelease);
  return cleanup;
};
